import React from 'react';
var selfStyles = require('./styles.scss');
var ListAthletesItemGender = function (props) {
    if (!props.gender) {
        return null;
    }
    var gender = props.gender.toLowerCase();
    if (gender === 'female' || gender === 'f') {
        return React.createElement("span", { className: selfStyles.athleteGenderFemale });
    }
    if (gender === 'male' || gender === 'm') {
        return React.createElement("span", { className: selfStyles.athleteGenderMale });
    }
    return null;
};
export default ListAthletesItemGender;



//////////////////
// WEBPACK FOOTER
// ./src/imports/components/Scoreboard/components/ListAthletesItemGender.tsx
// module id = 1016
// module chunks = 0